import React from 'react';
import { ThumbsUpButton, LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { notesReqApprovalActions } from '_actions';
import { NotesRequiringApprovalListItem } from 'MessageCenter/NotesRequiringApproval'
import styles from './List.module.css'

class NotesRequiringApprovalList extends React.Component {

    getListHeader() {
        if (this.props.loading === true)
            return (<LoadingIcon size="small" />);
        else if (this.props.approving === true)
            return (<LoadingIcon size="small" />);
        else if (this.props.messages && Object.keys(this.props.messages).length > 0)
            return (<span className={styles.approve_all_button_pointer} onClick={() => this.props.approveAllMsgs(Object.keys(this.props.messages).map(x => this.props.messages[x].id))}>
                <ThumbsUpButton size="medium" title='Approve All' />
            </span>);
        else if (this.props.messages && Object.keys(this.props.messages).length === 0)
            return (<div style={{ fontStyle: 'italic' }}>No Messages</div>);
        else
            return (<span />);
    }

    render() {
        return (
            <div>
                <div className={styles.approve_all_button_container}>
                    {this.getListHeader()}
                </div>
                <ScrollDiv divId={'MC_NOTES_REQ_APPROVAL'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .sort((a, b) => new Date(this.props.messages[b].noteDate) - new Date(this.props.messages[a].noteDate))
                        .map(key => {
                            const message = this.props.messages[key];
                            return <NotesRequiringApprovalListItem
                                key={message.id}
                                id={message.id}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let messages = Object.keys(state.entities.notesReqApproval)
        .sort((a, b) =>
            new Date(state.entities.notesReqApproval[b].lastEditDate).getTime() - new Date(state.entities.notesReqApproval[a].lastEditDate).getTime()
        )
        .map(x => state.entities.notesReqApproval[x]);

    return {
        messages,
        loading: state.ui.notesReqApproval.loading,
        approving: state.ui.notesReqApproval.approving
    };
}


function mapDispatchToProps(dispatch) {
    return {
        approveAllMsgs: bindActionCreators(notesReqApprovalActions.approveAll, dispatch)
    };
}

const connectedNotesRequiringApprovalList = connect(mapStateToProps, mapDispatchToProps)(NotesRequiringApprovalList);
export { connectedNotesRequiringApprovalList as NotesRequiringApprovalList };